import React from "react";
import StoreAction from "../constants/store-action";
import UserEvent from "../constants/user-event";
import { validateEcomData } from "../tools/data-validation";
import Alert from "../components/alert";
import CustomerInformationSummary from "../components/customer-information-summary";
import OrderSummary from "../components/order-summary";
import Spinner from "../components/spinner";
import { getRetailerInformation } from "../utils/retailer";
import { SOLD_TEXT } from "../constants/error-copy";
const handleCheckboxChange = (props, e) => {
    props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
        type: "customer",
        name: e.target.name,
        value: e.target.checked,
    });
};
const formatNewLines = (text) => {
    if (!text) {
        return null;
    }
    const lines = text.split("\n");
    return lines.map((l, index) => {
        const isFirst = index === 0;
        if (isFirst) {
            return React.createElement("span", { key: index }, l);
        }
        return (React.createElement("span", { key: index },
            React.createElement("br", null),
            l));
    });
};
export default (props) => {
    const [isConditionsExtended, setIsConditionsExtended] = React.useState(false);
    const [isReturnConditionsExtended, setIsReturnConditionsExtended,] = React.useState(false);
    const [hasError, setHasError] = React.useState(false);
    const [errorText, setErrorText] = React.useState("");
    React.useEffect(() => {
        if (props.vehicleUnavailable) {
            setHasError(true);
            setErrorText(SOLD_TEXT);
        }
    }, [props.vehicleUnavailable]);
    const address = props.getAddress();
    const createOrder = () => {
        setHasError(false);
        setErrorText("");
        const isValidData = validateEcomData(props.data, props.orderOptions, props.paymentLookup, address, props.creditAssessmentStatus);
        if (!isValidData) {
            setHasError(true);
            setErrorText("Något gick fel. Vi ber om ursäkt för det. Vänligen kontrollera uppgifterna i tidigare steg och försök igen.");
            return props.dispatchStoreAction(StoreAction.INTERACT_SET_ALL_FOR_TYPE, "customer");
        }
        props.onCreateOrder((isSuccessful) => {
            if (props.vehicleUnavailable) {
                setHasError(true);
                setErrorText(SOLD_TEXT);
                return;
            }
            else if (!isSuccessful) {
                setHasError(true);
                setErrorText("Order kunde inte skapas. Vi ber om ursäkt för det. Vänligen försök igen eller kontakta handlaren.");
                return;
            }
            props.onIncompleteUserEvent(UserEvent.ORDER_CREATED);
            props.onProceedToNextStep();
        });
    };
    const handleCreateOrderClick = () => {
        createOrder();
    };
    const handleShowConditionsClick = () => {
        setIsConditionsExtended(!isConditionsExtended);
    };
    const handleShowReturnConditionsClick = () => {
        setIsReturnConditionsExtended(!isReturnConditionsExtended);
    };
    const conditions = props.orderOptions.getOrderConditions();
    const returnConditions = props.orderOptions.getOrderReturnConditions();
    const conditionsPdfUri = props.orderOptions.getConditionsPdfUri();
    const formattedConditions = formatNewLines(conditions);
    const formattedReturnConditions = formatNewLines(returnConditions);
    const hasConditionsError = props.data.interact.customer.hasAcceptedConditions &&
        !props.data.customer.hasAcceptedConditions;
    const hasReturnConditionsError = props.data.interact.customer.hasAcceptedReturnConditions &&
        !props.data.customer.hasAcceptedReturnConditions;
    const canProceed = props.data.customer.hasAcceptedConditions &&
        (props.data.customer.hasAcceptedReturnConditions || !returnConditions);
    const onHandleCheckboxChange = (e) => handleCheckboxChange(props, e);
    const retailerInformation = getRetailerInformation(props.orderOptions);
    const retailerName = !!retailerInformation
        ? retailerInformation.name
        : "Handlaren";
    return (React.createElement("div", { "data-ecom-page": "" },
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, "Sammanst\u00E4llning"),
            React.createElement("div", { "data-ecom-content": "" },
                React.createElement("p", null,
                    "Granska och godk\u00E4nn din order f\u00F6r att reservera bilen. Efter det kommer ",
                    retailerName,
                    " att kontakta dig f\u00F6r att slutf\u00F6ra k\u00F6pet. K\u00F6pet blir bindande f\u00F6rst n\u00E4r du signerat det definitiva aff\u00E4rsf\u00F6rslaget med",
                    " ",
                    retailerName,
                    ". Det \u00E4r \u00E4ven d\u00E5 betalningen sker."))),
        React.createElement("section", { className: "page-section page-section-accent" },
            React.createElement(OrderSummary, Object.assign({}, props))),
        React.createElement("section", { className: "page-section" },
            React.createElement("h2", { className: "h6" }, "Kunduppgifter"),
            React.createElement(CustomerInformationSummary, Object.assign({}, props))),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { "data-ecom-form": "" },
                React.createElement("div", { className: `form-group ${hasConditionsError ? " has-error" : ""}` },
                    React.createElement("div", { "data-ecom-inputselection": "checkbox" },
                        React.createElement("input", { type: "checkbox", id: "checkbox-summary-conditions", name: "hasAcceptedConditions", checked: props.data.customer.hasAcceptedConditions, onChange: onHandleCheckboxChange }),
                        React.createElement("label", { htmlFor: "checkbox-summary-conditions" },
                            React.createElement("span", { className: "text" },
                                "Jag intygar att de angivna uppgifterna st\u00E4mmer, och jag godk\u00E4nner",
                                " ",
                                React.createElement("button", { "data-ecom-link": "", className: "valign-baseline", onClick: handleShowConditionsClick }, "k\u00F6pvillkor"))),
                        React.createElement("div", { className: "form-alert" }, "K\u00F6pvillkor beh\u00F6ver godk\u00E4nnas f\u00F6r att g\u00E5 vidare")))),
            isConditionsExtended && (React.createElement("div", { "data-ecom-scrollbox": "", className: "m-t" },
                React.createElement("article", { "data-ecom-content": "small-headings" },
                    React.createElement("h1", null, "K\u00F6pvillkor"),
                    React.createElement("p", null, formattedConditions)))),
            returnConditions && (React.createElement(React.Fragment, null,
                React.createElement("div", { "data-ecom-form": "", className: "m-t" },
                    React.createElement("div", { className: `form-group ${hasReturnConditionsError ? " has-error" : ""}` },
                        React.createElement("div", { "data-ecom-inputselection": "checkbox" },
                            React.createElement("input", { type: "checkbox", id: "checkbox-summary-return-conditions", name: "hasAcceptedReturnConditions", checked: props.data.customer
                                    .hasAcceptedReturnConditions, onChange: onHandleCheckboxChange }),
                            React.createElement("label", { htmlFor: "checkbox-summary-return-conditions" },
                                React.createElement("span", { className: "text" },
                                    "Jag godk\u00E4nner",
                                    " ",
                                    React.createElement("button", { "data-ecom-link": "", className: "valign-baseline", onClick: handleShowReturnConditionsClick }, "villkor f\u00F6r \u00E5ngerr\u00E4tt"))),
                            React.createElement("div", { className: "form-alert" }, "Villkor f\u00F6r \u00E5ngerr\u00E4tt beh\u00F6ver godk\u00E4nnas f\u00F6r att g\u00E5 vidare")))),
                isReturnConditionsExtended && (React.createElement("div", { "data-ecom-scrollbox": "", className: "m-t" },
                    React.createElement("article", { "data-ecom-content": "small-headings" },
                        React.createElement("h1", null, "Villkor f\u00F6r \u00E5ngerr\u00E4tt"),
                        React.createElement("p", null, formattedReturnConditions)))))),
            conditionsPdfUri && (React.createElement("div", { "data-ecom-content": "", className: "m-t" },
                React.createElement("a", { href: conditionsPdfUri, "data-ecom-link": "", title: "Ladda ner villkor (PDF)", target: "_blank", rel: "noopener noreferrer" },
                    "Ladda ner villkor (PDF)",
                    React.createElement("i", { className: "icon-link-external m-l-half" }))))),
        props.isWaitingForResponse && (React.createElement("section", { className: "page-section" },
            React.createElement(Spinner, null))),
        !!hasError && (React.createElement("section", { className: "page-section" },
            React.createElement(Alert, { message: errorText }))),
        !props.isWaitingForResponse && (React.createElement("section", { className: "page-section page-section-bottom" },
            React.createElement("div", { "data-ecom-buttonnav": "" },
                React.createElement("div", { className: "button-nav-item" },
                    React.createElement("button", { "data-ecom-button": "full-width", disabled: !canProceed, onClick: handleCreateOrderClick }, "Genomf\u00F6r k\u00F6p"))),
            React.createElement("div", { "data-ecom-content": "", className: "m-t m-b" },
                React.createElement("p", { className: "text-dark-lighten text-center font-size-small" }, "Med reservation f\u00F6r eventuell \u00E4ndring i tillg\u00E5ngen av utbjudna bilar"))))));
};
